// @flow
import React from 'react';

import { NativeInferencePoolContextProvider } from '../../contexts/NativeInferencePoolContextProvider';
import { NativeInferencePoolBreadcrumbs } from '../breadcrumbs/NativeInferencePoolBreadcrumbs';
import { ShowLoaderIfAnyQueryIsPending } from '../presentational/ShowLoaderIfAnyQueryIsPending';
import { UserContextProvider } from '../../contexts/UserContextProvider';
import { EstimateContextProvider } from '../../contexts/EstimateContextProvider';
import { AiAssistantEstimateContextBridge } from '../ai-assistant/AiAssistantEstimateContextBridge';

import { NativeInferencePoolTopLevelContainerForm } from './NativeInferencePoolTopLevelContainerForm';

export const NativeInferencePoolTopLevelContainer = () => {
  return (
    <>
      <ShowLoaderIfAnyQueryIsPending />
      <UserContextProvider>
        <EstimateContextProvider>
          <AiAssistantEstimateContextBridge />
          <NativeInferencePoolContextProvider>
            <NativeInferencePoolBreadcrumbs />
            <NativeInferencePoolTopLevelContainerForm />
          </NativeInferencePoolContextProvider>
        </EstimateContextProvider>
      </UserContextProvider>
    </>
  );
};
